"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HouseSvg = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var HouseSvg = function HouseSvg(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M27.29,11.4,17.2,1.9a2,2,0,0,0-2.4,0L4.71,11.4A2,2,0,0,0,4,12.93V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12.93A2,2,0,0,0,27.29,11.4ZM20,28H12V20a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2Z"
  }));
};
exports.HouseSvg = HouseSvg;
HouseSvg.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HouseSvg);
exports.default = _default;